"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hideWaitAnimation = exports.showWaitAnimation = exports.updateWaitAnimationRef = void 0;
const react_1 = require("react");
let customWaitAnimation = (0, react_1.createRef)();
const updateWaitAnimationRef = (ref) => {
    customWaitAnimation = ref;
    console.log('>>>>waitAnimation updated<<<< Not null: ', customWaitAnimation);
};
exports.updateWaitAnimationRef = updateWaitAnimationRef;
function showWaitAnimation() {
    if (customWaitAnimation.current) {
        //console.log("+++++++++++++++show Animation", waitAnimation);
        customWaitAnimation.current.style.display = 'block';
    }
}
exports.showWaitAnimation = showWaitAnimation;
function hideWaitAnimation() {
    if (customWaitAnimation.current) {
        //console.log("---------------hide Animation", waitAnimation);
        customWaitAnimation.current.style.display = 'none';
    }
}
exports.hideWaitAnimation = hideWaitAnimation;
